import { NumericFormat } from "react-number-format";
import style from "./style.module.scss";
import { toast } from "react-toastify";
import Required from "../Required";

const IntegerNumber = props => {
  const { value, valueChange = () => {}, placeholder = "", required, label, notzero } = props;
  const _value = value === null || value === undefined ? "" : value;

  return (
    <div className={style.input} data-label={!!label}>
      {!!label && (
        <span className={style.label}>
          {label} {!!required ? <Required /> : <></>}
        </span>
      )}
      <NumericFormat
        data-required={required}
        data-required-valid={required && !!_value}
        onValueChange={__ev => {
          if (!notzero || (!!notzero && !!(__ev?.floatValue || 0))) {
            valueChange(__ev.value || null);
          }
        }}
        placeholder={placeholder}
        onKeyPress={__ev => {
          __ev.key === "Enter" && __ev.target.blur();
        }}
        allowNegative={false}
        onBlur={__ev => {
          if (!!notzero && !parseInt(__ev?.target?.value || 0)) {
            valueChange(1);
            toast.error(notzero);
          }
        }}
        {...props}
        value={_value}
      />
    </div>
  );
};

export default IntegerNumber;
